<template>
  <v-container>
    <div id="app">
      <v-app id="inspire">
        <v-content>
          <v-container fluid fill-height>
            <v-layout align-center justify-center>
              <v-flex xs12 sm8 md6>
                <v-card class="elevation-12">
                  <v-toolbar dark color="#5ba322">
                    <v-toolbar-title>Anmeldung</v-toolbar-title>
                    <div class="spacer"></div>
                  </v-toolbar>
                  <v-card-text>
                    <v-form
                      ref="form"
                      lazy-validation
                      class="mic_form">
                      <v-text-field
                        prepend-icon="person"
                        name="email"
                        label="E-Mail"
                        id="email"
                        type="email"
                        :rules="emailRules"
                        :class="{ 'is-invalid': submitted && !email }"
                        v-model="email"
                        @keydown.enter.prevent="handleSubmit"
                        required>
                      </v-text-field>
                      <v-text-field
                        prepend-icon="lock"
                        name="password"
                        label="Passwort"
                        id="password"
                        type="password"
                        :rules="passwordRules"
                        :class="{ 'is-invalid': submitted && !password }"
                        v-model="password"
                        @keydown.enter.prevent="handleSubmit"
                        required>
                      </v-text-field>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-layout>
                      <v-flex xs-8>
                        <a href="/login/forgotpassword" style="color:black; text-decoration: none; margin-left: 15px">Passwort vergessen?</a>
                      </v-flex>
                      <v-flex xs-4>
                        <v-btn color="#f5a900" :disabled="loggedIn" @click="handleSubmit" class="white--text right">Anmelden</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-content>
      </v-app>
    </div>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      emailRules: [
        v => !!v || 'E-Mail ist ein Pflichfeld.'
      ],
      password: '',
      passwordRules: [
        v => !!v || 'Passwort ist ein Pflichfeld.'
      ],
      submitted: false
    }
  },
  computed: {
    loggedIn () {
      return this.$store.state.authentication.status.loggedIn
    }
  },
  created () {
    // reset login status
    this.$store.dispatch('authentication/logout')
  },
  methods: {
    handleSubmit () {
      if (this.$refs.form.validate()) {
        this.submitted = true
        const {email, password} = this
        const {dispatch} = this.$store
        if (email && password) {
          var redirectUrl = localStorage.getItem('redirectUrl')
          localStorage.removeItem('redirectUrl')
          dispatch('authentication/login', {email, password, redirectUrl})
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/login/LoginPage.vue